import React, { useState, useRef, useEffect } from 'react';
import ImageComponent from '../../../common/Image';
import { toast } from 'react-toastify';
import { QRCodeCanvas } from 'qrcode.react';
import PropTypes from 'prop-types';

const Lightbox = ({ stage, subStage, onRetrieve, qrCode, mandateUrl, mobileNumber }) => {
    // State to manage button disabled and timer
    const [isDisabled, setIsDisabled] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(0);
    const timerRef = useRef(null);

    // Cleanup timer on unmount
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    const getContent = () => {
        if ((stage === "kyc") && (subStage === "kyc-in-progress")) {
            return {
                message: "Please standby for completion of KYC by the customer.",
                buttonText: "Please press \"Retrieve Status\" post completion to continue."
            };
        }

        if (stage === "mandate") {
            return {
                message: "Please wait while mandate registration is completed by customer using the mandate link shared.",
                buttonText: "Please press \"Retrieve Status\" post completion to continue."
            };
        }

        if (stage === "document") {
            return {
                message: "Please wait for customer's acknowledgement on KFS and selection on promotional messages.",
                buttonText: "Please press \"Retrieve Status\" to continue, once accepted."
            };
        }

        if (stage === "imei_validation") {
            return {
                message: "Please standby and complete the device registration process on the new handset.",
                buttonText: "Please come back to this page once completed and press \"Retrieve Status\""
            };
        }

        // Default content for document stage
        return {
            message: "Please wait for customer's acknowledgement on KFS and selection on promotional messages.",
            buttonText: "Please press \"Retrieve Status\" to continue, once accepted."
        };
    };

    const content = getContent();

    // Handler for button click with 30s disable logic and countdown
    const handleRetrieveClick = () => {
        setIsDisabled(true);
        setSecondsLeft(30);
        if (typeof onRetrieve === 'function') {
            onRetrieve();
        }
        timerRef.current = setInterval(() => {
            setSecondsLeft(prev => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    setIsDisabled(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const copyLink = () => {
        navigator.clipboard.writeText(mandateUrl)
            .then(() => {
                toast.success("Link copied");
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    return (
        <>
            <div className="lightbox">
                <p>UPI Mandate Pending</p>
                <p>
                    The UPI mandate link has been sent to +91 {mobileNumber ? `******${mobileNumber.slice(-4)}` : ''}.
                    Please ask customer to complete mandate by:
                </p>
                <ul>
                    <li>Clicking link received on their mobile or </li>
                    <li>Scanning QR code below using any UPI app on their mobile</li>
                </ul>
                <p>
                    {!qrCode && <ImageComponent fileName="new-coin.gif" alt="coin" className="coin-overlay" /> ||
                        <QRCodeCanvas value={qrCode} size={128} />}
                </p>
                <p>Once mandate is completed, you'll be redirected automatically. If not, tap "Retrieve Status"</p>
                <>
                    <button
                        className='btn lightbox-btn'
                        onClick={handleRetrieveClick}
                        disabled={isDisabled}
                    >
                        Retrieve Status
                    </button>
                    {isDisabled && (
                        <p className='mt-2 small fw-normal'>
                            You can retry in {secondsLeft} second{secondsLeft !== 1 ? 's' : ''}.
                        </p>
                    )}
                </>
                {(stage === "mandate" || stage === 'document') &&
                    <div className='mt-2'>
                        <button
                            onClick={copyLink}
                            className='copy-link-btn'
                            onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
                            onMouseOut={(e) => e.target.style.backgroundColor = "#007bff"}
                            onFocus={(e) => e.target.style.backgroundColor = "#0056b3"}
                            onBlur={(e) => e.target.style.backgroundColor = "#007bff"}
                        >
                            Copy Link
                        </button>
                    </div>}
            </div>
        </>
    );
};

Lightbox.propTypes = {
    stage: PropTypes.string.isRequired,       // or PropTypes.number depending on your type
    subStage: PropTypes.string.isRequired,    // or PropTypes.number
    onRetrieve: PropTypes.func.isRequired,    // Validates that it's a function
    qrCode: PropTypes.string.isRequired,      // Assumes string (like a URL or base64)
    mandateUrl: PropTypes.string.isRequired,  // Assumes string URL
};

export default Lightbox;